import React from 'react';
import Select from 'react-select';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';


export default class TrainingScreen extends React.Component {

    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args

        this.state = {instituteOptions: [],
                      productOptions: [],  
                      programOptions: [], 
                      regionOptions: [],
                      args: args,
                      currentTraining: {id: null, 
                                        name: "", 
                                        programId: null,
                                        program: "",
                                        productid: null,
                                        product: "",
                                        institutionid: null,
                                        institution: "",
                                        regionid:"",
                                        region:"",
                                        occupation: 0,
                                        start: null,
                                        end: null}};

        this.handleChangeName = this.handleChangeName.bind(this);   
        this.handleChangeStart = this.handleChangeStart.bind(this);
        this.handleChangeEnd = this.handleChangeEnd.bind(this);
        this.handleChangeOccupation = this.handleChangeOccupation.bind(this);         
        this.handleChangeInstitution = this.handleChangeInstitution.bind(this); 
        this.handleChangeProduct = this.handleChangeProduct.bind(this); 
        this.handleChangeProgram = this.handleChangeProgram.bind(this); 
        this.handleChangeRegion = this.handleChangeRegion.bind(this); 

        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.training && this.props.args.training.length > 0) {
            BaseApi.get("/training", {headers: {
                'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {id: this.props.args.training}, withCredentials: true})
            .then(res => {
                this.setState({currentTraining: res.data})
            })    
            .catch()
        }

        BaseApi.get("/institutions", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
        .then(res => {
            const instituteOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({instituteOptions: instituteOptions})
        })    
        .catch()

        BaseApi.get("/programs", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
        .then(res => {
            const programOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({programOptions: programOptions})
        })    
        .catch()

        BaseApi.get("/products", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
        .then(res => {
            const productOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({productOptions: productOptions})
        })    
        .catch()

        BaseApi.get("/regions", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
        .then(res => {
            const regionOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({regionOptions: regionOptions})
        })    
        .catch()
    }


    save(event) {
        BaseApi.post('/training', this.state.currentTraining, {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeName(event) {
        var currentTraining = this.state.currentTraining
        currentTraining.name = event.target.value
        this.setState({currentTraining: currentTraining})
    }

    handleChangeStart(event) {
        var currentTraining = this.state.currentTraining
        currentTraining.start = event.target.value
        this.setState({currentTraining: currentTraining})
    }

    handleChangeEnd(event) {
        var currentTraining = this.state.currentTraining
        currentTraining.end = event.target.value
        this.setState({currenTraining: currentTraining})
    }

    handleChangeOccupation(event) {
        var currentTraining = this.state.currentTraining
        currentTraining.occupation = event.target.value
        this.setState({currentTraining: currentTraining})
    }

    handleChangeInstitution(selectedOption) {
        var currentTraining = this.state.currentTraining
        currentTraining.institutionid = selectedOption.value
        currentTraining.institution= selectedOption.label
        this.setState({currentTraining: currentTraining})
    }

    handleChangeRegion(selectedOption) {
        var currentTraining = this.state.currentTraining
        currentTraining.regionid = selectedOption.value
        currentTraining.region = selectedOption.label
        this.setState({currentTraining: currentTraining})
    }

    handleChangeProduct(selectedOption) {
        var currentTraining = this.state.currentTraining
        currentTraining.productid = selectedOption.value
        currentTraining.product= selectedOption.label
        this.setState({currentTraining: currentTraining})
    }

    handleChangeProgram(selectedOption) {
        var currentTraining = this.state.currentTraining
        currentTraining.programid = selectedOption.value
        currentTraining.program = selectedOption.label
        this.setState({currentTraining: currentTraining})
    }

    openParticipants() {
        this.props.navigate("training-participant", 
        {caller: "training", callargs: this.state.args, trainingid: this.state.currentTraining.id, training: this.state.currentTraining})
    }

    render() {
    
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Обучение"}/>
                <div class="row mt-5">
                    <div class="col-md-6">
                        <form>
                            <div class="form-group">
                                <label for="name">Название:</label>
                                <input type="text" class="form-control" id="name" value={this.state.currentTraining.name} onChange={this.handleChangeName} />
                                <label for="start">Начало:</label>
                                <input type="date" class="form-control" id="start"  value={this.state.currentTraining.start} onChange={this.handleChangeStart} />
                                <label for="end">Завершение:</label>
                                <input type="date" class="form-control" id="end"  value={this.state.currentTraining.end} onChange={this.handleChangeEnd} />
                                <label for="occupation">Занятость волонтера:</label>
                                <input type="number" class="form-control" id="occupation"  value={this.state.currentTraining.occupation} onChange={this.handleChangeOccupation} />
                                <label for="institution">Регион:</label>
                                <Select options= {this.state.regionOptions} 
                                        id="region" 
                                        onChange={this.handleChangeRegion}
                                        placeholder={this.state.currentTraining.region}    
                                        />
                                <label for="institution">Учреждение:</label>
                                <Select options= {this.state.instituteOptions} 
                                        id="institution" 
                                        onChange={this.handleChangeInstitution}
                                        placeholder={this.state.currentTraining.institution}    
                                        />
                                <label for="program">Программа:</label>        
                                <Select options= {this.state.programOptions} 
                                        id="program" 
                                        onChange={this.handleChangeProgram}
                                        placeholder={this.state.currentTraining.program}    
                                        />   
                                <label for="product">Продукты:</label>        
                                <Select options= {this.state.productOptions} 
                                        id="product" 
                                        onChange={this.handleChangeProduct}
                                        placeholder={this.state.currentTraining.product}    
                                        />                     
                            </div>
                        </form>
                    </div>
                    <div class="col-md-3 offset-3">
                        <div class="row">
                            <button class="btn btn-primary w-100" onClick={()=>{this.openParticipants()}}>Участники</button>  
                        </div> 
                        <div class="row mt-3">
                            <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>  
                        </div>
                    </div>
                </div>
            </div>
            
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/training/training.js